import { Injectable } from '@angular/core'
import { Params, Router, UrlSegment } from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs'
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators'

/** Manages navigation to the desired target, when faced with obstacles like login or not yet loaded dynamic routes. */
@Injectable({
  providedIn: 'root'
})
export class NavSupportService {
  private _$desiredUrl: BehaviorSubject<{ url: UrlSegment[] | string; queryParams?: Params }> = new BehaviorSubject<{
    url: UrlSegment[] | string
    queryParams?: Params
  }>(null)

  /** holds the desired url, which was either set before a refresh or before a redirect to the login area.*/
  desiredUrl$: Observable<{ url: UrlSegment[] | string; queryParams?: Params }> = this._$desiredUrl
    .asObservable()
    .pipe(distinctUntilChanged())

  /** holds the desired url, which was either set before a refresh or before a redirect to the login area.
   * Suppresses empty values.
   */
  desiredUrlWithoutEmptyValues$: Observable<{ url: UrlSegment[] | string; queryParams?: Params }> =
    this.desiredUrl$.pipe(filter((data) => !!data?.url))

  /** Determines, whether this service holds a 'desired URL'. */
  hasDesiredUrl$: Observable<boolean> = this.desiredUrl$.pipe(map((data) => !!data?.url))

  constructor() {}

  setDesiredUrl(url: UrlSegment[] | string, queryParams?: Params) {
    if (typeof url === 'string' && url.startsWith('/init')) {
      // console.log('won\'t set /init route!');
      return
    }
    this._$desiredUrl.next({ url, queryParams })
  }

  /** sets the desired URL to null. */
  reset = () => {
    this.setDesiredUrl(null)
  }

  navigateToDesiredUrl = (router: Router): void => {
    this.desiredUrlWithoutEmptyValues$.pipe(take(1)).subscribe((target) => {
      if (!target?.url) {
        console.log('Could not navigate to desired URL, since it is not set.')
        return
      }
      const urlStr = typeof target.url === 'string' ? target.url : `/${target.url.map((us) => us.path).join('/')}`
      // console.log('navigate to desired url. urlStr: ', urlStr, (<any>(target.queryParams))?.params);
      router.navigateByUrl(urlStr)
      this.reset()
    })
  }
}
